<template>
  <div class="modal-alert">
    <sweet-modal ref="modal" width="600" @close="$emit('close')">
      <div class="alert-modal-content">
        <div v-if="content" class="subtitle4 main">{{ content }}</div>
        <slot></slot>

        <div class="button-group">
          <button class="button is-primary" @click="clickAccept">완료</button>
        </div>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
  import { SweetModal } from "sweet-modal-vue";
  export default {
    name: "ModalAlert",
    components: {
      SweetModal
    },
    props: {
      content: {
        type: String
      }
    },
    created() {

    },
    data() {
      return {}
    },
    methods: {
      open() {
        this.$refs.modal.open();
      },
      clickAccept() {
        this.$emit('close');
        this.$refs.modal.close();
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .alert-modal-content
    display flex
    align-items center
    flex-direction column
    text-align center

  .button-group
    margin-top 40px
    display grid
    grid-gap 8px
    .button
      width 300px
      height 44px !important
</style>
<style lang="stylus">
  .modal-alert
    .sweet-modal.is-alert .sweet-content
      padding 60px 32px 40px 32px
</style>
